import React from 'react';

import {
  MatchPasswordRulesContainer,
  CheckRules,
  Rule,
  RuleCheck,
  RuleCheckIcon,
  RuleMessage,
} from './styledComponents';

/**
 * Checklist of the password rules, as returned by getPasswordRegexRules / getPasswordValidation.
 * A plain indicator is used instead of the library Checkbox, which has no green checked state.
 */
const PasswordRules = (props) => {
  const { rules } = props;

  return (
    <MatchPasswordRulesContainer>
      <CheckRules>
        {!!rules &&
          Object.keys(rules).map((ruleName) => {
            if (ruleName === 'all') {
              return;
            }

            const { isValid, message } = rules[ruleName];

            return (
              <Rule key={ruleName}>
                <RuleCheck $isValid={isValid}>
                  {isValid && <RuleCheckIcon alt="" src="/images/inpulse/check-white-small.svg" />}
                </RuleCheck>
                <RuleMessage>{message}</RuleMessage>
              </Rule>
            );
          })}
      </CheckRules>
    </MatchPasswordRulesContainer>
  );
};

export default PasswordRules;
